import React from 'react';
import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import BoardWrite from 'components/board/BoardWrite';

// 게시판 관리 > 주요결과 관리 > 등록
export default function PerformanceWrite() {
  const boardType = 'performance';

  return (
    <Section>
      <PageTitle title="성과자료실 등록" />
      <BoardWrite boardType={boardType} />
    </Section>
  );
}
